// ko strings for messages/train.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const train: Dict = {
  "train.seo.title": "나만의 AI 목소리 학습 | Jammable",
  "train.seo.description":
    "Jammable에서 나만의 AI 목소리를 학습시켜 보세요. 오디오 파일을 업로드해 목소리 모델을 학습시키고, 커뮤니티에 공유하거나 비공개로 보관할 수 있어요.",
  "train.h1": "목소리 학습시키기",
  "train.sub":
    "깨끗한 노래나 말소리 몇 분이면 커버에 쓸 수 있는 목소리가 만들어져요.",
  "train.voicesTrained": "목소리 {count}개 학습 완료",

  "train.faq.title": "자주 묻는 질문",
  "train.faq.dataset.q": "데이터셋이 뭔가요?",
  "train.faq.dataset.a1": "보컬이 담긴 오디오 파일 모음이에요.",
  "train.faq.dataset.a2":
    "최소 {min}분 이상의 노래나 말소리가 필요하고, 10분 이상이면 더 좋아요.",
  "train.faq.dataset.a3": "MP3, WAV, M4A 형식을 지원해요.",
  "train.faq.private.q": "내 목소리를 비공개로 할 수 있나요?",
  "train.faq.private.a":
    "네! 비공개로 설정하면 나만 내 목소리 모델에 접근하고, 보고, 사용할 수 있어요!",
  "train.faq.time.q": "목소리 학습에는 얼마나 걸리나요?",
  "train.faq.time.a":
    "추가한 오디오 양에 따라 달라요. 보통 10분 분량이면 {short}, 1시간 분량이면 {long} 걸려요. 페이지를 닫아도 괜찮아요. 완료되면 이메일로 알려 드릴게요.",

  // How long training takes (lib/train/eta minutesLabel, same rounding).
  "train.eta.minutes": "약 {m}분",
  "train.eta.hour": "약 {h}시간",
  "train.eta.hours": "약 {h}시간",
  "train.eta.hourMinutes": "약 {h}시간 {m}분",
  "train.eta.hoursMinutes": "약 {h}시간 {m}분",
  "train.minutes": "{n}분",

  // Shared by both steps' summary cards
  "train.samples": "샘플",
  "train.filesOne": "파일 1개 · {time}",
  "train.filesMany": "파일 {n}개 · {time}",
  "train.passesLeft": "남은 학습권",
  "train.unlimited": "무제한",
  "train.nameIt": "이름 정하기",
  "train.creatorShort": "학습은 Creator 플랜에 포함돼요.",

  // Step 1: upload or record
  "train.upload.invalidType": "지원하지 않는 파일 형식이에요.",
  "train.upload.skippedOne":
    "{names}은(는) 이미 추가되어 건너뛰었어요. 같은 오디오를 두 번 넣어도 목소리가 좋아지지 않아서 한 번만 반영돼요.",
  "train.upload.skippedMany":
    "{names}은(는) 이미 추가되어 건너뛰었어요. 같은 오디오를 두 번 넣어도 목소리가 좋아지지 않아서 한 번만 반영돼요.",
  "train.upload.nFiles": "파일 {n}개",
  "train.upload.someInvalid": "올바르지 않은 파일이 있어요.",
  "train.upload.failed": "업로드 실패",
  "train.upload.needsPlan": "업로드하려면 플랜이 필요해요",
  "train.upload.tooManyLabel":
    "지금은 업로드가 너무 많아요. 잠시 후 다시 시도하세요",
  "train.upload.tooManyToast":
    "지금은 업로드가 너무 많아요. 몇 분 후에 다시 시도해 주세요.",
  "train.upload.analysing": "파일에서 무음 구간을 찾고 있어요. 잠시만요.",
  "train.upload.blocked": "차단된 파일이 있어요. 계속하려면 삭제해 주세요.",
  "train.upload.errored":
    "오류가 있는 파일이 있어요. 계속하려면 삭제해 주세요.",
  "train.upload.processing":
    "아직 처리 중인 파일이 있어요. 끝날 때까지 기다려 주세요.",
  "train.upload.tooShort":
    "무음을 제외한 노래나 말소리가 {min} 필요해요. 지금은 {have}예요.",
  "train.upload.tooLong":
    "오디오는 최대 {max}까지 가능해요. 지금은 {have}이니 파일을 삭제하거나 일부를 잘라 주세요.",
  "train.upload.title": "내 목소리 추가",
  "train.upload.ofMin": "/ {min}",
  "train.upload.overLimit": "{n}분 제한보다 {over} 초과",
  "train.upload.ready": "준비 완료 ✓",
  "train.upload.addMore": "{left} 더 추가하세요",
  "train.upload.short":
    "목소리는 보통 {n}분 이상일 때 더 좋게 들려요. 지금 학습을 시작해도 되고, 오디오가 더 있다면 {left} 더 추가해 보세요.",
  "train.upload.uploadFiles": "파일 업로드",
  "train.upload.record": "녹음",
  "train.upload.addIt": "추가",
  "train.upload.recordHint":
    "노래하거나 말해 보세요. 원하는 만큼 녹음할 수 있어요.",
  "train.upload.blockedFrom": "차단됨 - {label}의 콘텐츠",
  "train.upload.gettingReady": "준비 중...",
  "train.upload.ofVoice": "목소리 {time}",
  "train.upload.removed": "{time} 제거됨",
  "train.upload.uploading": "업로드 중...",
  "train.upload.done": "완료",
  "train.upload.trim": "자르기",
  "train.upload.retry": "다시 시도",
  "train.upload.remove": "{name} 삭제",
  "train.upload.silenceNote":
    "무음은 자동으로 제거돼요. 보라색 부분이 목소리가 학습하는 구간이에요.",
  "train.upload.tip1.title": "목소리는 하나만",
  "train.upload.tip1.sub": "코러스나 관중 소리 없이",
  "train.upload.tip2.title": "조용한 공간",
  "train.upload.tip2.sub": "울림이나 배경 소음 없이",
  "train.upload.tip3.title": "많을수록 좋아요",
  "train.upload.tip3.sub": "다양한 음높이와 단어로",
  "train.upload.nextHint": "다음 단계: 이름, 사진, 공개 범위 정하기.",
  "train.upload.cardTitle": "내 샘플",
  "train.upload.footnote":
    "노래나 말소리 최소 {min}({rec} 이상이면 더 좋아요), 최대 {max}. 무음과 중복 파일은 포함되지 않으며, 무음은 자동으로 잘라 드려요.",
  "train.upload.footnoteNoRec":
    "노래나 말소리 최소 {min}, 최대 {max}. 무음과 중복 파일은 포함되지 않으며, 무음은 자동으로 잘라 드려요.",
  "train.upload.creatorNote":
    "학습은 Creator 플랜에 포함돼요. 먼저 보컬을 업로드하고 마지막에 결정하세요. 결제 전에 가격을 확인할 수 있어요.",
  "train.upload.continue": "계속",

  // A sample's play button and the trim editor
  "train.sample.play": "{label} 재생",
  "train.sample.pause": "{label} 일시정지",
  "train.clip.keptOf": "/ {total} 유지",
  "train.clip.silenceCut": "무음 {time} 잘림",
  "train.clip.cutByYou": "직접 자른 부분 {time}",
  "train.clip.cut": "잘림",
  "train.clip.play": "재생",
  "train.clip.stop": "정지",
  "train.clip.keepIt": "유지",
  "train.clip.cutIt": "자르기",
  "train.clip.cancel": "취소",
  "train.clip.hint":
    "원하지 않는 부분을 드래그해 선택한 뒤 잘라 내세요. 탭하면 들어 볼 수 있어요.",
  "train.clip.undo": "자른 부분 되돌리기",

  // Step 2: name, picture, settings, start
  "train.info.samplesAdded": "추가된 샘플",
  "train.info.edit": "수정",
  "train.info.namePlaceholder": "목소리 이름 (예: 내 목소리)",
  "train.info.descPlaceholder":
    "설명 - 이 목소리를 어떻게 학습시켰는지 커뮤니티에 알려 주세요...",
  "train.info.whoCanUse": "공개 범위",
  "train.info.private": "비공개, 나만 사용",
  "train.info.public": "라이브러리에 공개",
  "train.info.cleanUp": "샘플 정리",
  "train.info.removeInstrumentals": "반주 제거",
  "train.info.removeInstrumentalsSub":
    "데이터셋에서 보컬이 아닌 소리를 걸러 내요.",
  "train.info.removeReverb": "리버브 제거",
  "train.info.removeReverbSub": "데이터셋 오디오의 리버브를 제거해요.",
  "train.info.cardTitle": "학습 준비 완료",
  "train.info.usuallyReadyIn": "보통 완료까지",
  "train.info.upTo2h": "최대 2시간",
  "train.info.closePage": "학습은 서버에서 진행되니 페이지를 닫아도 괜찮아요.",
  "train.info.starting": "시작하는 중...",
  "train.info.start": "학습 시작",
  "train.info.orGetPass": "또는 학습권 구매",
  "train.info.getMorePasses": "학습권 더 구매하기",
  "train.info.usesOnePass": "학습권 1개 사용",
  "train.info.started": "학습이 시작됐어요",
  "train.info.onCreator": "Creator 플랜을 이용 중이에요. 학습을 시작할게요...",
  "train.info.legal":
    "계속 진행하면 업로드한 콘텐츠를 사용할 권리를 Jammable에 부여하며, 이 콘텐츠가 본인 소유이고 제3자의 저작권 자료를 포함하지 않음을 확인합니다.",
  "train.info.agreeTerms": "이용약관에 동의해 주세요!",
  "train.info.chooseName": "목소리 이름을 정해 주세요!",
  "train.info.uploadImage": "이미지를 업로드해 주세요!",
  "train.info.invalidName":
    "올바르지 않은 모델 이름이에요. 특수 문자는 쓸 수 없어요",
  "train.info.signIn": "로그인이 필요해요",
  "train.info.errorStarting": "학습을 시작하지 못했어요",
  "train.info.errorSignedUrl": "업로드 URL을 가져오지 못했어요",

  // Demo under step 1 (components/CustomModelDemo)
  "train.demo.title": "학습된 목소리 들어 보기",
  "train.demo.by": "Jammable 파워 유저 제작",
  "train.demo.data.label": "학습 데이터",
  "train.demo.data.note": "몇 분 분량의 목소리",
  "train.demo.input.label": "입력 노래",
  "train.demo.input.note": "이 목소리가 부를 노래",
  "train.demo.output.label": "최종 결과",
  "train.demo.output.note": "학습된 목소리로 부른 노래",
  "train.demo.play": "{label} 재생",
  "train.demo.pause": "{label} 일시정지",

  // Failed voice card (RetryTraining). The refuse.* lines mirror the
  // messages in lib/train/retry.ts, which the API sends in English.
  "train.retry.trainAgain": "다시 학습시키기",
  "train.retry.tryAgain": "다시 시도",
  "train.retry.orNewSamples": "또는 새 샘플로 학습시키기",
  "train.retry.retrying":
    "다시 학습 중이에요. 완료되면 이메일로 알려 드릴게요.",
  "train.retry.couldntStart": "학습을 시작하지 못했어요. 다시 시도해 주세요.",
  "train.retry.confirmUnlimited":
    "같은 샘플로 다시 학습시킬게요. 플랜에 포함되어 있어요.",
  "train.retry.confirmOutCreator":
    "다시 시도하려면 학습권이 필요한데 남은 학습권이 없어요. 학습은 Creator 플랜에 포함돼요.",
  "train.retry.confirmOut":
    "다시 시도하려면 학습권이 필요한데 남은 학습권이 없어요.",
  "train.retry.confirmPass":
    "같은 샘플로 다시 학습시킬게요. 학습권 1개가 사용돼요(보유: {passes}개). 다시 실패하면 학습권을 돌려 드려요.",
  "train.retry.cancel": "취소",
  "train.retry.seeCreator": "Creator 보기",
  "train.retry.getPass": "학습권 구매",
  "train.retry.orGetPass": "또는 학습권 구매",
  "train.retry.starting": "시작하는 중...",
  "train.retry.usePass": "학습권 사용하고 다시 시도",
  "train.retry.refuse.cleanVocals":
    "다시 시도해도 같은 이유로 실패해요. 음악이나 긴 무음이 없는 깨끗한 보컬로 다시 학습시켜 주세요.",
  "train.retry.refuse.formats":
    "다시 시도해도 같은 이유로 실패해요. 노래나 말소리가 또렷한 MP3, WAV, M4A 파일로 다시 학습시켜 주세요.",
  "train.retry.refuse.newSamples":
    "다시 시도해도 같은 이유로 실패해요. 새 샘플로 다시 학습시켜 주세요.",
  "train.retry.refuse.saveAs":
    "다시 시도해도 같은 이유로 실패해요. MP3나 WAV로 저장한 뒤 다시 학습시켜 주세요.",
  "train.retry.refuse.filesMissing": "새 샘플로 다시 학습시켜 주세요.",
  "train.retry.refuse.retryCap":
    "이 목소리는 이미 {n}번 시도했어요. 가능하면 다른 샘플로 다시 학습시켜 주세요.",

  // TrainFinalStage (not currently rendered)
  "train.final.confirm": "확인",
  "train.final.back": "이전",
  "train.final.next": "다음",
};

export default train;
